// This file is automatically generated. Do not edit manually.

import { ShopOrderAggregatedSourceView } from "src/api/generated/erp/db/types/tables/shopOrderAggregatedSourceView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ShopOrderAggregatedSourcesDataGridApi {
	export async function getData(args: { shopOrderId: number }): Promise<Array<ShopOrderAggregatedSourceView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrder/shopOrderAggregatedSourcesDataGrid/getData",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
			},
		});
		return response as Array<ShopOrderAggregatedSourceView>;
	}
}
